<!--
 * @Description: 累计结算报告。 v3版bi场景，没有累计，老BI场景还是有累计
 * @Date: 2021-07-02 15:28:33
-->
<template>
  <el-dialog
    width="482px"
    title="数据包查看"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible="true"
    :before-close="() => $emit('close')"
  >
    <div>
      <div>
        <div class="app-title">项目</div>
        <el-checkbox-group v-model="checkList" class="checkbox-group">
          <el-checkbox
            :label="item.type"
            v-for="item in group"
            :key="item.type"
            :disabled="item.btn && item.btn.disabled"
          >
            <span>{{ item.name }}</span>
            <el-button
              type="text"
              v-if="item.btn"
              @click="item.btn.fn"
              :disabled="
                item.btn && (item.btn.disabled || item.btn.openDisabled)
              "
            >
              {{ item.btn.name }}
            </el-button>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div>
        <div class="app-title">
          个人
        </div>
        <el-checkbox-group v-model="checkList" class="checkbox-group">
          <el-checkbox
            :label="item.type"
            v-for="item in group1"
            :key="item.type"
            :disabled="item.btn && item.btn.disabled"
          >
            <span>{{ item.name }}</span>
            <el-button
              type="text"
              v-if="item.btn"
              @click="item.btn.fn"
              :disabled="item.btn && item.btn.disabled"
            >
              {{ item.btn.name }}
            </el-button>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="color: #FF0000; font-size:14px;" v-if="showTips">
        提示：任务记录包较大，下载时间较长，请按需下载
      </div>
      <el-row :gutter="10" type="flex" justify="center" class="pt30">
        <el-button
          @click="submit"
          type="primary"
          :disabled="checkList.length == 0 || loading || disabledDownloadBtn"
        >
          下 载
        </el-button>
        <el-button @click="$emit('close')" type="info">
          取 消
        </el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { biBase, BIv2, confirm } from '@/api/ajax.js';
import createBiReport from '@/components/createBiReport';
import store from '@/store';
import createExtend from '@C/createExtend';
import setBiModule from '@/page/project-task-submit/child/data-dialog-bimodule';
import dataReportImgDialog from './data-report-img-dialog.vue';

const chartsType = type => {
  const obj = {
    2: 'otc',
    5: 'dcwj',
    7: 'dcwj',
    9: 'gradeHospital',
    10: 'jcyljg',
    20: 'makeScene'
  };
  return obj[type];
};

export default {
  name: 'TaskForm3',
  //数据包查看 data-dialog.vue
  props: [
    'statementId',
    'isAll',
    'biInfoIdFromList',
    'disabledEdit',
    'autoCheckList',
    'aspSubmitDt',
    'rowData',
    'acceptance',
    'audit',
    'isShow',
    'csoStatus',
    'isMaterialDownload' //因材料下载也要用这样弹窗，区分
  ],
  data() {
    return {
      loading: false,
      biInfoId: 0,
      checkList: [],
      cumulativeStatus: 0, // 累计BI状态 2可下载， 勾选累计后调用getFenpeiIdList判断是否可点击下载与返回得biStatus一直，不勾选为2
      currentPeriodStatus: 0, // 当期BI状态 2可下载 1初始化  2成功 3失败,
      currentPeriodTimer: null, // 当期BI状态 轮询
      isShowImageVersion: 0,
      newBiList: []
    };
  },
  watch: {
    checkList: {
      handler: function(v) {
        if (!this.isNewBi202207) {
          return;
        }
        // 如果是 20227月 新版bi  勾选了 累计BI 弹框 缓存 选择的模块数据
        if (v.includes(6) && !this.newBiList.includes(6)) {
          const { id: projectId } = this.homeProject;
          //点击 累计BI报告
          let form = createExtend(setBiModule, {
            biInfoId: this.biInfoId,
            projectId
          });
          form.$on('confirm', checkList => {
            // 缓存 累计bi 详细选项
            this.newBiList = JSON.parse(JSON.stringify(checkList));
            form.remove();
          });
        }
        //如果是 20227月 新版bi  取消勾选了 累计BI 弹框 清空 选择的模块数据
        if (!v.includes(6) && this.newBiList.includes(6)) {
          this.newBiList = [];
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      homeProject: state => state.homeProject
    }),
    noBi() {
      return ![2, 5, 6, 7, 9, 10, 20, 21].includes(
        +store.state.homeProject.projectType
      );
    },
    // 5调研问卷 20可配置 21数字问卷 19协定服务  6数字专区 17数字拜访
    allScene() {
      return [5, 6, 17, 19, 20, 21].includes(
        +store.state.homeProject.projectType
      );
    },
    isActivity() {
      const { projectType, fileUpMode, fileUpSource } = this.homeProject;
      //协定服务活动形式的
      const showActivity =
        +projectType === 19 && (+fileUpMode === 1 || fileUpSource === 3);
      return showActivity;
    },
    isOldBi() {
      return [2, 9, 10].includes(+store.state.homeProject.projectType);
    },
    isNewBi() {
      return [5, 6, 7, 20, 21].includes(+store.state.homeProject.projectType);
    },
    isNewBi202207() {
      // 2022 版bi
      return [5, 20].includes(+store.state.homeProject.projectType);
    },
    showTips() {
      return this.checkList.filter(item => item != 5 && item != 6).length > 0;
    },
    disabledDownloadBtn() {
      // 勾选并当期BI状态不为2
      if (this.currentPeriodStatus !== 2 && this.checkList.includes(5)) {
        return true;
      }
      // 勾选并且累计BI状态不为2
      if (this.cumulativeStatus !== 2 && this.checkList.includes(6)) {
        return true;
      }
      // 单个数据包,没有任务提交时间， 禁用下载按钮
      return !this.isAll && !this.aspSubmitDt;
    },
    group() {
      const { isAll, isActivity, allScene } = this;
      const dis =
        (!this.biInfoId && !this.isOldBi) ||
        (this.isAll &&
          Array.isArray(this.statementId) &&
          this.statementId.length == 0);
      return [
        {
          hide: this.noBi || isAll,
          type: 5,
          name: '当期BI报告',
          btn: {
            name: '查看',
            disabled: (this.rowData && +this.rowData.currentBiId === -1) || dis,
            openDisabled: this.currentPeriodStatus !== 2,
            fn: this.openBi.bind(null, this.isNewBi202207 ? 201 : 45)
          }
        },
        {
          hide: this.noBi || !isAll,
          type: 6,
          name: '累计BI报告',
          btn: {
            name: '查看',
            disabled: dis,
            openDisabled: this.cumulativeStatus !== 2, // 使用初始备份数据
            fn: this.openBi.bind(null, this.isNewBi202207 ? 202 : 46)
          }
        },
        {
          hide: isAll,
          type: 1,
          name: '当期数据报表'
        },
        // todo：联调
        {
          hide: isAll || ![5, 17, 20].includes(this.homeProject.projectType),
          type: 10,
          name: '当期数据报表图片版',
          btn: {
            disabled: +this.isShowImageVersion === 0
          }
        },
        {
          hide: !isAll,
          type: 2,
          name: '累计数据报表'
        },
        {
          hide: isAll || isActivity,
          type: 7,
          name: '当期任务记录'
        },
        {
          hide: !isAll || isActivity,
          type: 8,
          name: '累计任务记录'
        },
        {
          hide: isAll || !allScene || !this.isShow,
          btn: {
            disabled: !this.acceptance
          },
          type: 141,
          name: '当期项目验收报告'
        },
        {
          hide:
            isAll || ![5, 20, 17, 19].includes(this.homeProject.projectType),
          btn: {
            disabled: !this.audit
          },
          type: 140,
          // name: '当期项目审核报告',
          name: '当期项目执行报告'
        }
      ].filter(item => !item.hide);
    },
    group1() {
      const { isAll } = this;
      return [
        {
          hide: isAll,
          type: 3,
          name: '当期个人数据报表'
        },
        {
          hide: isAll || ![5, 17, 20].includes(this.homeProject.projectType),
          type: 11,
          name: '当期个人数据报表图片版',
          btn: {
            disabled: +this.isShowImageVersion === 0
          }
        },
        {
          hide: !isAll,
          type: 4,
          name: '累计个人数据报表'
        }
      ].filter(item => !item.hide);
    }
  },
  methods: {
    createBi() {
      let fn = null;
      if (
        [5, 20].includes(
          this.isMaterialDownload
            ? +this.homeProject.projectType
            : +this.$route.query.projectType
        )
      ) {
        fn = BIv2.saveBiInfo;
      } else {
        fn = biBase.saveBiInfo;
      }
      fn({
        projectId: this.isMaterialDownload
          ? this.homeProject.id
          : this.$route.query.id,
        fenpeiId: this.statementId,
        type: 1
      }).then(res => {
        try {
          this.biInfoId = res.data.data.biInfoId || 0;
          this.currentPeriodStatus = +res.data.data.biStatus;
          this.currentPeriodLoop(this.biInfoId);
        } catch (error) {
          console.warn('生成BI报告数据失败');
        }
      });
    },
    async openBi(selectType) {
      const { projectType, id } = this.isMaterialDownload
        ? this.homeProject
        : this.$route.query;
      // 如果是 可配置20，或者调研5
      if (this.isNewBi202207) {
        if (this.newBiList.length) {
          await BIv2.updateBiModuleById({
            moduleJsonStr: JSON.stringify(this.newBiList)
          });
        }
        this.$openV3BI({
          id: this.biInfoId,
          selectType,
          projectType,
          projectId: this.isMaterialDownload
            ? this.homeProject.id
            : this.$route.query.id
        }); // 新版BI
        return;
      }
      setTimeout(() => {
        if (this.isOldBi) {
          const biRoute = this.$router.resolve({
            name: 'bi-old',
            query: {
              fenpeiIdArr: Array.isArray(this.statementId)
                ? this.statementId
                : [this.statementId],
              serviceType: chartsType(projectType),
              projectId: id
            }
          });
          window.open(biRoute.href, '_blank');
        } else {
          this.$openV3BI({
            id: this.biInfoId,
            selectType,
            isEdit: +!this.disabledEdit,
            projectType,
            projectId: this.isMaterialDownload
              ? this.homeProject.id
              : this.$route.query.id
          });
        }
      }, 300);
    },
    async submit() {
      this.loading = true;
      let biUrl = null;
      const { id, projectType } = this.isMaterialDownload
        ? this.homeProject
        : this.$route.query;
      if (
        this.isOldBi &&
        (this.checkList.includes(5) || this.checkList.includes(6))
      ) {
        // 选择了bi,并且是历史样式
        biUrl = await new Promise(resolve => {
          createBiReport({
            localQuery: {
              fenpeiIdArr: Array.isArray(this.statementId)
                ? this.statementId
                : [this.statementId],
              serviceType: chartsType(projectType),
              projectId: id,
              isAutoExport: true,
              callback: ({ fileUrl }) => {
                resolve(fileUrl);
              }
            }
          });
        });
      }
      // 如果是活动形式去掉当期任务记录和累计任务记录
      if (this.isActivity) {
        this.checkList = this.checkList.filter(item => ![7, 8].includes(item));
      }

      // 如果是 可配置20，或者调研5
      if (this.newBiList.length && this.isNewBi202207) {
        await BIv2.updateBiModuleById({
          moduleJsonStr: JSON.stringify(this.newBiList)
        });
      }

      let selectList = JSON.parse(JSON.stringify(this.checkList));

      if (selectList.includes(5) && this.isNewBi202207) {
        let i = selectList.findIndex(j => j === 5);
        selectList.splice(i, 1, 201);
      }
      //可配置20，或者调研5场景才有这个弹窗
      let dataReportImgData = {};
      if (selectList.includes(10) && [20, 5].includes(Number(projectType))) {
        try {
          dataReportImgData = await this.dataReportImg();
        } catch (error) {
          console.log(error);
          this.loading = false;
          return;
        }
      }
      biBase
        .projectCurrent({
          ...dataReportImgData,
          id: this.statementId,
          projectId: this.isMaterialDownload
            ? this.homeProject.id
            : this.$route.query.id,
          selectType: selectList.join(','),
          doctorProject: this.homeProject.type,
          biUrl
        })
        .then(() => {
          this.loading = false;
          this.$emit('close');
          this.$message.success(
            this.showTips
              ? '正在生成，当前涉及的数据量较大，生成完后可前往下载中心进行下载'
              : '正在生成，生成完后可前往下载中心进行下载'
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * Description:   可配置和调研图片版的弹窗
     */
    dataReportImg() {
      return new Promise((resolve, reject) => {
        const submitDialog = createExtend(dataReportImgDialog, {
          projectType: this.homeProject.projectType,
          fenPeiId: this.statementId
        });
        submitDialog.$on('sendData', res => {
          resolve(res);
          submitDialog.remove();
        });
        submitDialog.$on('cancel', () => {
          reject('cancel');
          submitDialog.remove();
        });
      });
    },
    currentPeriodLoop(biInfoId) {
      // 生成中轮询BI状态接口
      if (![2, 3].includes(this.currentPeriodStatus) && biInfoId) {
        this.currentPeriodTimer = setInterval(async () => {
          if ([5, 20].includes(+this.homeProject.projectType)) {
            const {
              data: { data }
            } = await biBase.getNumberQuestionBiStatusV2({
              biInfoId,
              projectId: this.isMaterialDownload
                ? this.homeProject.id
                : this.$route.query.id
            });
            this.currentPeriodStatus = +data;
          } else {
            const {
              data: { data }
            } = await biBase.getNumberQuestionBiStatus({ biInfoId });
            this.currentPeriodStatus = +data;
          }

          if ([2, 3].includes(this.currentPeriodStatus)) {
            clearTimeout(this.currentPeriodTimer);
          }
        }, 2500);
      }
    }
  },
  created() {
    if (Array.isArray(this.autoCheckList)) {
      this.checkList = [...this.autoCheckList];
    }
    // 获取累计BI生成状态
    if (this.isAll) {
      let assignFn = null;
      if ([5, 20].includes(+this.homeProject.projectType)) {
        assignFn = biBase.getFenpeiIdListV2;
      } else {
        assignFn = biBase.getFenpeiIdList;
      }
      assignFn({
        projectId: this.homeProject.id,
        startTime: 0,
        endTime: 0,
        type: 2
      }).then(({ data: { data } }) => {
        this.cumulativeStatus = (data[0] || { biStatus: 0 }).biStatus;
      });
    }
    if (this.isAll || this.biInfoIdFromList) {
      this.biInfoId = this.biInfoIdFromList;
      this.currentPeriodLoop(this.biInfoId);
    } else if (this.isNewBi && this.csoStatus == 1) {
      this.createBi();
    }
    if ([5, 17, 20].includes(this.homeProject.projectType)) {
      const { fenpeiId } = this.rowData;
      const { id: projectId } = this.homeProject;
      confirm
        .showTheHiddenImageVersion({
          fenpeiId,
          projectId
        })
        .then(res => {
          this.isShowImageVersion = res.data.data;

          if (+this.isShowImageVersion !== 0) {
            this.checkList = [...this.checkList, 10, 11];
          }
        });
    } else {
      this.isShowImageVersion = 0;
    }
  },
  beforeDestroy() {
    this.currentPeriodTimer && clearTimeout(this.currentPeriodTimer);
  }
};
</script>
<style lang="scss" scoped>
.app-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 500;
  color: #2e2f2f;
  line-height: 24px;
}

.app-title::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 24px;
  background: #1989fa;
  margin-right: 8px;
}

.checkbox-group {
  width: 420px;
  border-radius: 6px;
  border: 1px dashed #e3e3e3;
  padding: 30px 20px;
  padding-bottom: 10px;
  margin-top: 20px;
  margin-bottom: 15px;

  .el-checkbox {
    margin-bottom: 20px;
  }
}
</style>
